import { TextField, TextFieldProps } from '@mui/material';
import { cognitiveReadOperationResult } from 'api/document/cognitiveReadOperationResult';
import { useDrop } from 'react-dnd';

export type TextFieldWithDropProps = {
  onDrop?: (item: cognitiveReadOperationResult) => void;
} & TextFieldProps;

export const TextFieldWithDrop = (props: TextFieldWithDropProps) => {
  const { value, onDrop, ...rest } = props;

  const [{ canDrop, isOver }, drop] = useDrop(() => ({
    accept: 'CHIP',
    drop: (value: { item: cognitiveReadOperationResult }) => {
      if (value.item.type === 'System.String') {
        !!onDrop && onDrop(value.item);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop() && monitor.getItem().item.type === 'System.String'
    })
  }));

  return (
    <div>
      <TextField
        value={value ?? undefined}
        inputRef={drop}
        label={props.label}
        fullWidth
        style={{
          backgroundColor: isOver && canDrop ? '#c8e6c9' : 'white'
        }}
        disabled={props.disabled}
        {...rest}
      />
    </div>
  );
};
